import SliderManager from "./SliderManager.js";

const partnersSlider = new SliderManager({
  selector: ".partners__list",
  splideOptions: {
    label: "Наши партнёры",
    type: "loop",
    perPage: 1,
    perMove: 1,
    pagination: true,
    arrows: true,
    autoWidth: true,
    trimSpace: false,
    updateOnMove: true,
    waitForTransition: true,
    gap: "32px",
    mediaQuery: "min",
    breakpoints: {
      768: {
        perPage: 4,
        perMove: 3,
        padding: { right: "0" },
      },
      1280: {
        perPage: 6,
        perMove: 1,
        padding: { right: "20%" },
      },
    },
  },
  globalVarName: "partnersSlider",
  resizeDelay: 250,
  dynamicWrapper: {
    trackClass: "partners__slider-track",
    itemClass: "partners__item",
  },
});

partnersSlider.init();
